import classNames from "classnames";
import { DatasetStatusEnum } from "types";

import styles from "./style.module.scss";

const DatasetStatusComponent = ({ datasetStatus }: DatasetStatusProps) => {
  const statusButtonClassnames = classNames(styles.statusButton, {
    [styles.readyButton]: datasetStatus === DatasetStatusEnum.READY,
    [styles.progressButton]: [
      DatasetStatusEnum.INDEXING,
      DatasetStatusEnum.UPLOADING,
      DatasetStatusEnum.ENRICHING,
      DatasetStatusEnum.PRE_PROCESSING,
      DatasetStatusEnum.SAVING,
    ].includes(datasetStatus),
    [styles.initializingButton]: [
      DatasetStatusEnum.INITIALIZING,
      DatasetStatusEnum.NEW,
    ].includes(datasetStatus),
    [styles.errorButton]: datasetStatus === DatasetStatusEnum.FATAL_ERROR,
  });

  return (
    <div className={styles.datasetStatusContainer}>
      <button className={statusButtonClassnames}>{datasetStatus}</button>
    </div>
  );
};

export default DatasetStatusComponent;

interface DatasetStatusProps {
  datasetStatus: DatasetStatusEnum;
}
